<script setup>
import { ArrowRightIcon } from "@heroicons/vue/20/solid";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t: __ } = useI18n();

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    processing: {
        type: Boolean,
        default: false,
    },
    showIcon: {
        type: Boolean,
        default: true,
    },
    label: {
        type: String,
    },
    icon: {
        default: undefined,
    },
});

const _label = computed(() => {
    if (typeof props.label === "function") {
        return props.label();
    }

    if (props.label === undefined) {
        return __("Continuer");
    }

    return props.label;
});
</script>

<template>
    <button
        type="button"
        :class="[
            'inline-flex items-center relative transition rounded-md bg-gray-900 dark:bg-gray-900 py-4 px-12 text-xl font-semibold text-white shadow-sm',
            disabled
                ? 'opacity-50 cursor-default'
                : 'cursor-pointer hover:bg-gray-950 dark:hover:bg-gray-800 group focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-950 dark:focus-visible:outline-gray-800',
        ]"
        :disabled="disabled">
        <div :class="[processing ? 'invisible' : '', 'inline-flex items-center gap-x-1.5']">
            {{ _label }}
            <Component
                v-if="showIcon"
                :is="icon !== undefined ? icon : ArrowRightIcon"
                class="-mr-0.5 transform w-6 h-6 transition-transform group-hover:translate-x-0.5"
                aria-hidden="true" />
        </div>
        <div v-if="processing" class="absolute inset-0 flex justify-center items-center">
            <svg class="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </button>
</template>
